import './Filter.scss';

import React from 'react';
import Popout from 'src/ui/library/Popout';
import FilterListIcon from '@material-ui/icons/FilterList';
import DatePicker from 'src/ui/library/DatePicker';
import ButtonComponent from 'src/new-ui/library/ButtonComponent/ButtonComponent';
import Dropdown from 'src/ui/library/Dropdown';
import { getCaseFiltersAPI, getAppTypesByCountry } from 'src/services/dashboard.service';
import intl from 'react-intl-universal';
// import _ from 'lodash';

export class Filter extends React.Component {
  state = {
    // filters: {
    applicationType: null,
    createdDate: null,
    homeCountry: null,
    hostCountry: null,
    policy: null,
    service: null,
    targetDateEnd: null,
    targetDateStart: null,
    // },
    filters: {},
    policyOptions: [],
    serviceOptions: [],
    hostCountryOptions: [],
    homeCountryOptions: [],
    localApplicationTypeOptions: [],
    filtersDataResponse: null,
  };

  componentDidMount() {
    this.getCaseFilter();
  }

  getCaseFilter = () => {
    getCaseFiltersAPI().then(response => {
      if (!response) {
        return;
      }
      if (typeof response.filters === 'undefined') {
        throw new Error('onRequestData expected API response to contain `rows`');
      }

      const { policies, services, countries, applicationTypes } = response.filters;

      if (this.props.onFilterResponse) {
        this.props.onFilterResponse(response.filters);
      }

      let policyOptions = policies ? policies.map(item => ({ value: item.id, label: item.name })) : [];
      let serviceOptions = services ? services.map(item => ({ value: item.id, label: item.name })) : [];
      let hostCountryOptions = countries ? countries.map(item => ({ value: item.id, label: item.name })) : [];
      let homeCountryOptions = countries ? countries.map(item => ({ value: item.id, label: item.name })) : [];
      let localApplicationTypeOptions = applicationTypes
        ? applicationTypes.map(item => ({ value: item.ey_applicationtypeid, label: item.ey_name }))
        : [];

      this.setState(prevState => ({
        policyOptions: policyOptions,
        serviceOptions: serviceOptions,
        totalCaseCount: response.totalCaseCount,
        hostCountryOptions: hostCountryOptions,
        homeCountryOptions: homeCountryOptions,
        localApplicationTypeOptions: localApplicationTypeOptions,
        filtersDataResponse: response.filters,
      }));
    });
  };

  getApplicationType = countryId => {
    getAppTypesByCountry(countryId).then(response => {
      if (this.props.onApplicationTypeResponse) {
        this.props.onApplicationTypeResponse(response);
      }
      let localApplicationTypeOptions = response ? response.map(item => ({ value: item.ey_applicationtypeid, label: item.ey_name })) : [];
      this.setState({
        localApplicationTypeOptions: localApplicationTypeOptions,
      });
    });
  };

  handleOnChange = (id, event) => {
    let newValue = event && event.target ? event.target.value : event;
    switch (id) {
      case 'policy': {
        this.setState({ policy: newValue });
        break;
      }
      case 'service': {
        this.setState({ service: newValue });
        break;
      }
      case 'createdDate': {
        this.setState({ createdDate: newValue });
        break;
      }
      case 'targetDateStart': {
        this.setState({ targetDateStart: newValue });
        break;
      }
      case 'targetDateEnd': {
        this.setState({ targetDateEnd: newValue });
        break;
      }
      case 'hostCountry': {
        this.setState({ hostCountry: newValue });
        this.getApplicationType(newValue);
        this.setState(prevState => ({ filters: { ...prevState.filters, applicationType: undefined } }));
        break;
      }
      case 'homeCountry': {
        this.setState({ homeCountry: newValue });
        break;
      }
      case 'applicationType': {
        this.setState({ applicationType: newValue });
        break;
      }
      default: {
      }
    }

    this.setState(prevState => ({ filters: { ...prevState.filters, [id]: newValue } }));
  };

  handleApply = () => {
    if (this.props.onChange) {
      this.props.onChange(this.state.filters);
    }
    if (this.props.onSetFilter) {
      this.props.onSetFilter(this.state.filters);
    }
    this.closePopout();
  };

  handleClear = () => {
    if (this.props.onClearFilter) {
      this.props.onClearFilter(this.state.filters);
    }
    if (this.props.onAllPillClear) {
      this.props.onAllPillClear();
    }
    this.clearAllFilter();
    this.closePopout();
  };

  clearAllFilter = () => {
    this.setState({
      filters: {},
      applicationType: null,
      createdDate: null,
      homeCountry: null,
      hostCountry: null,
      policy: null,
      service: null,
      targetDateEnd: null,
      targetDateStart: null,
      localApplicationTypeOptions: [],
    });
  };

  clearFilterByKey = key => {
    let removeFromFilter = this.state.filters;
    delete removeFromFilter[key];
    this.setState(prevState => ({
      filters: removeFromFilter,
    }));

    switch (key) {
      case 'policy': {
        this.setState({ policy: null });
        break;
      }
      case 'service': {
        this.setState({ service: null });
        break;
      }
      case 'createdDate': {
        this.setState({ createdDate: null });
        break;
      }
      case 'targetDateStart': {
        this.setState({ targetDateStart: null });
        break;
      }
      case 'targetDateEnd': {
        this.setState({ targetDateEnd: null });
        break;
      }
      case 'hostCountry': {
        this.setState({ hostCountry: null });
        break;
      }
      case 'homeCountry': {
        this.setState({ homeCountry: null });
        break;
      }
      case 'applicationType': {
        this.setState({ applicationType: null });
        break;
      }
      default: {
      }
    }
  };

  render() {
    return (
      <div className="popout-container">
        <Popout
          style={{ width: '613px' }}
          orientation={'right'}
          hoverable={false}
          triggerClose={fn => (this.closePopout = fn)}
          trigger={
            <div className="filter-icon-container">
              <FilterListIcon />
              <label style={{ fontSize: '10px' }}>Filter</label>
            </div>
          }
          content={
            <div className="filter-popup-container">
              <div className="select-field-spacing">
                <Dropdown
                  options={this.state.policyOptions}
                  label={intl.get('cases.filters.labels.policy')}
                  onChange={event => this.handleOnChange('policy', event)}
                  value={this.state.policy}
                />
              </div>
              <div className="select-field-spacing">
                <Dropdown
                  options={this.state.serviceOptions}
                  label={intl.get('cases.filters.labels.service')}
                  onChange={event => this.handleOnChange('service', event)}
                  value={this.state.service}
                />
              </div>
              <div className="select-date-picker">
                <DatePicker
                  label={intl.get('cases.filters.labels.createdDate')}
                  onChange={event => this.handleOnChange('createdDate', event)}
                  value={this.state.createdDate}
                />
              </div>

              <div className="select-date-picker">
                <DatePicker
                  label={intl.get('cases.filters.labels.from')}
                  onChange={event => this.handleOnChange('targetDateStart', event)}
                  value={this.state.targetDateStart}
                />
              </div>

              <div className="select-date-picker">
                <DatePicker
                  label={intl.get('cases.filters.labels.to')}
                  onChange={event => this.handleOnChange('targetDateEnd', event)}
                  value={this.state.targetDateEnd}
                />
              </div>
              <div className="select-field-spacing">
                <Dropdown
                  options={this.state.hostCountryOptions}
                  label={intl.get('cases.filters.labels.hostCountry')}
                  onChange={event => this.handleOnChange('hostCountry', event)}
                  value={this.state.hostCountry}
                />
              </div>
              <div className="select-field-spacing">
                <Dropdown
                  options={this.state.homeCountryOptions}
                  label={intl.get('cases.filters.labels.homeCountry')}
                  onChange={event => this.handleOnChange('homeCountry', event)}
                  value={this.state.homeCountry}
                />
              </div>
              <div>
                <Dropdown
                  options={this.state.localApplicationTypeOptions}
                  label={intl.get('cases.filters.labels.applicationType')}
                  onChange={event => this.handleOnChange('applicationType', event)}
                  value={this.state.applicationType}
                />
              </div>
              <div className="popout-footer-buttons">
                <ButtonComponent
                  onClick={() => {
                    this.handleClear();
                  }}
                  text={intl.get('table.labels.clearAll')}
                  className="secondary enableCursor"></ButtonComponent>
                |
                <ButtonComponent
                  onClick={() => {
                    this.handleApply();
                  }}
                  text={intl.get('table.labels.apply')}
                  className="secondary enableCursor"></ButtonComponent>
              </div>
            </div>
          }
        />
      </div>
    );
  }
}

export default Filter;
